
    var riot = require('riot')
    //src: starling/src/tags/selection-area.html
riot.tag2('selection-area',
  '',
  '',
  'class="selection-area" riot-style="{getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _selectionUi = require('lib/selection-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

canvas.selectionArea = this;

this.origX = 0;
this.origY = 0;
this.currentX = 0;
this.currentY = 0;
this.height = 0;
this.width = 0;
this.visibility = 'hidden';
this.currentSelection = {};
this.emptyCount = 0;

this.disable = function () {
  _this.isDisabled = true;
};

this.enable = function () {
  _this.isDisabled = false;
};

this.resetSelectionBox = function () {
  _this.origX = 0;
  _this.origY = 0;
  _this.currentX = 0;
  _this.currentY = 0;
  _this.height = 0;
  _this.width = 0;
};

this.getStyle = function () {
  return '\n        top: ' + (_this.origY < _this.currentY ? _this.origY : _this.currentY) + 'px;\n        left: ' + (_this.origX < _this.currentX ? _this.origX : _this.currentX) + 'px;\n        height: ' + _this.height + 'px;\n        width: ' + _this.width + 'px;\n        visibility: ' + _this.visibility + ';\n      ';
};

this.selectAllInsideBox = function () {
  var left = Math.min(_this.origX, _this.currentX);
  var right = Math.max(_this.origX, _this.currentX);
  var top = Math.min(_this.origY, _this.currentY);
  var bottom = Math.max(_this.origY, _this.currentY);
  _selectionUi.selectionUI.selectAllInsideBox({ left: left, right: right, top: top, bottom: bottom });

  _this.update();
};

this.resetSelectionAreaTarget = function () {
  _this.setupDragging();
};

this.startSelecting = function () {
  canvas.selecting = true;
  canvas.isClickedFlag = false;
  canvas.stashCurrentSelection();
  canvas.disablePanZoom();
};

this.stopSelecting = function (_ref) {
  var enablePanZoom = _ref.enablePanZoom;

  canvas.selecting = false;
  if (enablePanZoom) {
    canvas.enablePanZoom();
  }
  _this.hideBox();
  canvas.multiSelectionIndicatorBox.update();
};

this.hideBox = function () {
  if (_this.visibility == 'visible') {
    _this.visibility = 'hidden';
    _this.selectAllInsideBox();
    _this.update();
  }
};

this.setupDragging = function (element) {
  if (_this.dragger) _this.dragger.off();
  _this.dragger = (0, _interactjs2.default)(element || '.selection-area-enabled').styleCursor(false).draggable({
    onstart: function onstart(e) {
      if (!canvas.space) {
        //passing a function through opts downcases it....
        //(getMatrix => getmatrix)
        if (_this._isDisabled) {
          return;
        }

        var _opts$getmatrix = _this.opts.getmatrix(),
            scale = _opts$getmatrix.scale,
            tx = _opts$getmatrix.tx,
            ty = _opts$getmatrix.ty;

        _selectionUi.selectionUI.resetNodeRects();
        _this.startSelecting();
        _this.origX = (e.clientX - tx - scale) / scale, _this.origY = (e.clientY - ty - scale) / scale, _this.update();
      }
    },
    onmove: function onmove(e) {
      if (_this.isDisabled) {
        return;
      }
      if (!canvas.space) {
        var _opts$getmatrix2 = _this.opts.getmatrix(),
            scale = _opts$getmatrix2.scale,
            tx = _opts$getmatrix2.tx,
            ty = _opts$getmatrix2.ty;

        var currentX = (e.clientX - tx) / scale;
        var currentY = (e.clientY - ty) / scale;
        if (!canvas.selecting) {
          _this.startSelecting();
          _this.origX = currentX - 1;
          _this.origY = currentY - 1;
        }
        _this.currentX = currentX;
        _this.currentY = currentY;
        _this.width = Math.abs(_this.currentX - _this.origX);
        _this.height = Math.abs(_this.currentY - _this.origY);
        _this.visibility = 'visible';
        _this.selectAllInsideBox();
      } else {
        _this.stopSelecting({ enablePanZoom: false });
      }
    },
    onend: function onend(e) {
      var store = canvas.store;
      var links = store.links,
          regions = store.regions,
          drawings = store.drawings;

      _this.height = 0;
      _this.width = 0;

      _this.stopSelecting({ enablePanZoom: true });

      if (!canvas.selectedElements.length && (store.getNodesSize() || links.length || regions.length || drawings.length)) {
        _this.emptyCount += 1;
        setTimeout(function (_) {
          return _this.emptyCount -= 1;
        }, 2000);
        if (_this.emptyCount >= 3 || !sessionStorage.getItem("spacepan")) {
          canvas.notificationTag.show({ message: 'Tip: Use space+drag to pan around the map', icon: 'pan_tool' });
        }
      }
    }
  });
};

this.on('mount', function () {
  _this.resetSelectionAreaTarget(opts.canvaselement);
});

this.selectAllInsideBox = (0, _lodash2.default)(this.selectAllInsideBox);
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('selection-area')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/selection-area.html
// module id = 602
// module chunks = 0